export default {
  HOME_PAGE: 'HOME_PAGE',
};
